import React from 'react';
import {
    HORSE_RACING_STREAMS,
    STREAM_MODE_AU,
    STREAM_MODE_SA,
    STREAM_MODE_EN,
} from 'constants/appConfig';
import Wrapper from 'ui/Wrapper';
import StreamTypesDropdown from 'features/HorseRacingStream/StreamTypesDropdown';
import LiveStream from '../MatchCenterAndLiveStream/LiveStream';

class HorseRacingStream extends React.PureComponent {
    state = {
        fastTrackUrl: '',
        streamType: STREAM_MODE_AU,
    };

    selectStreamingType = (type) => {
        this.setState({
            streamType: type,
        });
    };
    selectFT = () => {
        this.selectStreamingType(STREAM_MODE_AU);
    };

    getStreamTypes = () => ({
        [STREAM_MODE_AU]: {
            title: 'Australien',
            streamTypeSetter: () =>
                this.setState({ streamType: STREAM_MODE_AU }),
            src: HORSE_RACING_STREAMS.STREAM_MODE_AU,
            hls: true,
        },
        [STREAM_MODE_SA]: {
            title: 'Sydafrika',
            streamTypeSetter: () =>
                this.setState({ streamType: STREAM_MODE_SA }),
            src: HORSE_RACING_STREAMS.STREAM_MODE_SA,
            hls: true,
        },
        [STREAM_MODE_EN]: {
            title: 'England',
            streamTypeSetter: () =>
                this.setState({ streamType: STREAM_MODE_EN }),
            src: HORSE_RACING_STREAMS.STREAM_MODE_EN,
            hls: true,
        },
    });
    componentDidMount() {
        this.selectFT();
    }

    render() {
        const streamTypes = this.getStreamTypes();
        const streamTypeAttributes = streamTypes[this.state.streamType];

        return (
            <Wrapper padding="40px 0 0 " position="relative">
                <StreamTypesDropdown
                    streamTypes={streamTypes}
                    selectedStreamType={this.state.streamType}
                />
                <LiveStream isHorse streamUrl={streamTypeAttributes.src} />
            </Wrapper>
        );
    }
}

export default HorseRacingStream;
